import Copy from "./Copy";
import Detail from "./Detail";
import {RouterProps} from "../../RouterProps";
import {Route, Routes} from "react-router-dom";
import List from "./List";
import Post from "./Post";

export default function AgreementRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/post'} element={<Post {...props} />} />
            <Route path={'/:envAgreementId'} element={<Detail {...props} />} />
            <Route path={'/:envAgreementId/copy'} element={<Copy {...props} />} />
        </Routes>
    </>
}